var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91545 0C2.2792 0 1.74878 0.530422 1.74878 1.16667V13.4167C1.74881 13.7388 2.00996 14 2.33211 14H9.33211C9.65427 14 9.91541 13.7388 9.91545 13.4167V10.7917C9.91545 10.6306 10.046 10.5 10.2071 10.5H10.4988C10.8279 10.5 11.0821 10.7543 11.0821 11.0833V11.6667C11.0821 12.6263 11.8725 13.4167 12.8321 13.4167C13.7917 13.4167 14.5821 12.6263 14.5821 11.6667V4.08333C14.5821 3.53302 14.3228 3.01329 13.8826 2.68311L12.0152 1.28288C11.7302 1.06917 11.3659 1.17254 11.1983 1.40023C11.0072 1.65982 11.0576 2.02402 11.3157 2.21712L12.0152 2.74121C12.1623 2.85141 12.2489 3.02452 12.2488 3.20833V4.66667C12.2488 5.20472 12.6263 5.66622 13.1272 5.79687C13.2827 5.83743 13.4154 5.96392 13.4154 6.125V11.6667C13.4154 11.9957 13.1612 12.25 12.8321 12.25C12.503 12.25 12.2488 11.9957 12.2488 11.6667V11.0833C12.2488 10.1237 11.4584 9.33333 10.4988 9.33333H10.2071C10.046 9.33333 9.91545 9.20275 9.91545 9.04167V1.16667C9.91545 0.530422 9.38502 1.75e-08 8.74878 1.75e-08L2.91545 0ZM3.20711 1.16667H8.45711C8.6187 1.16667 8.74878 1.29675 8.74878 1.45833V5.54167C8.74878 5.70325 8.6187 5.83333 8.45711 5.83333H3.20711C3.04553 5.83333 2.91545 5.70325 2.91545 5.54167V1.45833C2.91545 1.29675 3.04553 1.16667 3.20711 1.16667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.e3ab5414099759484cc89a65f28f85be.svg";
export { ForwardRef as ReactComponent };